import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsMenuComponent } from './reports-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,

    RouterModule,
    MatIconModule
  ],
  declarations: [ReportsMenuComponent]
})
export class ReportsMenuModule { }
